import type { Customer } from "../api/types";

type TFunc = (key: string, opts?: Record<string, unknown>) => string;

/**
 * Warn before a warranty-certificate export (XLSX or 3-PDF) when the target
 * customer is missing the contract number / contract date — those fields drive
 * the certificate's NR / DATA and render empty when unset. Returns true to
 * proceed (all set, or the user confirmed), false to abort.
 */
export function confirmWarrantyContract(cust: Customer | undefined | null, t: TFunc): boolean {
  const missing: string[] = [];
  if (!cust?.contract_number) missing.push(t("warranty.missNr"));
  if (!cust?.contract_date) missing.push(t("warranty.missDate"));
  if (missing.length === 0) return true;
  return window.confirm(
    t("warranty.missConfirm", { name: cust?.name ?? "?", fields: missing.join(" + ") }),
  );
}
